import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { ru } from 'vuetify/locale'

const lightTheme = {
  dark: false,
  colors: {
    primary: '#1976D2', // Blue 700 - более тёмный основной
    secondary: '#424242', // Grey 800 - нейтральный
    accent: '#00BCD4', // Cyan 500 - яркий акцент
    error: '#F44336', // Red 500 - стандартный error
    info: '#29B6F6', // Light Blue 400 - информационный
    success: '#66BB6A', // Green 400 - успех
    warning: '#FFA726', // Orange 400 - предупреждение
    background: '#FAFAFA',
    surface: '#FFFFFF',
  },
}

const darkTheme = {
  dark: true,
  colors: {
    primary: '#0D47A1', // Blue 900 - глубокий тёмный
    secondary: '#616161', // Grey 700 - нейтральный
    accent: '#29B6F6', // Light Blue 400 - яркий акцент для контраста
    error: '#EF5350', // Red 400 - видимый на тёмном
    info: '#42A5F5', // Blue 400 - информационный
    success: '#66BB6A', // Green 400 - успех
    warning: '#FFA726', // Orange 400 - предупреждение
    background: '#121212',
    surface: '#1E1E1E',
  },
}

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'ru',
    messages: { ru },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
  defaults: {
    VCard: {
      elevation: 2,
    },
    VBtn: {
      variant: 'flat',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
  },
})
